module.exports = function(){
    
     this.Code             = Number
    ,this.CorrelationToken = String
    ,this.ErrorIdentifier  = String
    ,this.FullException    = Object
    ,this.Message          = String

}